<div class="form-group">
  <label *ngIf="props.label" [for]="id" class="form-label tt_norms400">
    {{ props.label }}
    <span class="text-danger" *ngIf="props.required">*</span>
  </label>

  <irembogov-cascading-editable-input
    [id]="id"
    [configs]="cascadingConfigs"
    [items]="items"
    [loading]="loading"
    [formlyAttributes]="field"
    [formControl]="formControl"
    [isTouched]="showError"
    [linear]="props['linear'] || false"
    (activeDropDown)="onActiveDropdownChange($event)"
    (valueChange)="onValueChange($event)">
  </irembogov-cascading-editable-input>

  <div class="invalid-feedback" [style.display]="showError ? 'block' : 'none'">
    <formly-validation-message [field]="field"></formly-validation-message>
  </div>

  <small *ngIf="props.description" class="form-text text-muted">
    {{ props.description }}
  </small>
</div>
